











































import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { BoardActionsKeys, BoardActionsPayload } from '@/store/types/board';

@Component({})
export default class CreateLabel extends Vue {
  @Action(BoardActionsKeys.CREATE_LABEL) createLabel!: (payload: BoardActionsPayload['CREATE_LABEL']) => Promise<void>;

  @Ref('createLabelForm') labelForm!: Vue;

  dialog = false;
  validLabelForm = true;

  labelName = '';

  errors: string[] = [];

  @Watch('dialog')
  setNewLabel() {
    this.labelName = '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (this.labelForm) (this.labelForm as any).resetValidation();
  }

  @Watch('labelName')
  clearErrors() {
    if (this.errors.length) this.errors = [];
  }

  labelDataValidations = {
    name: [(v: string) => !!v || 'Label name is required'],
  };

  async createNewLabel() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    try {
      if ((this.labelForm as any).validate()) {
        await this.createLabel(this.labelName);
        this.dialog = false;
      }
    } catch (e) {
      if ((e as any).response.status === 409) {
        this.errors.push('Label already exists');
      }
    }
  }
}
